export const roller_bat_bag = {
  msrp: 89.99,
  infoLink: 'https://www.teamtriton.com/bat-bag.html',
  items: [
    {
      number: 'L-01',
      hasModel: false,
    },
    {
      number: 'L-02',
      hasModel: false,
    },
    {
      number: 'L-03',
      hasModel: false,
    },
    {
      number: 'L-04',
      hasModel: false,
    },
    {
      number: 'L-05',
      hasModel: false,
    },
    {
      number: 'L-06',
      hasModel: false,
    },
  ],
};
